export function isCcpa(tenant, locale) {
  return (
    tenant.toLowerCase() !== "vista" && locale.toLowerCase().endsWith("-us")
  );
}
